import Wallop from 'wallop';

export default function banner() {
    var banner = $('.banner');

    if (banner.find('li').length < 2) {
        return;
    }

    var instance = new Wallop(banner[0], {
        itemClass: 'slide',
        currentItemClass: 'current',
        showPreviousClass: 'show-previous',
        showNextClass: 'show-next',
        hidePreviousClass: 'hide-previous',
        hideNextClass: 'hide-next',
        carousel: true
    });

    setInterval(function() {
        instance.next();
    }, 5000);
};
